export enum ConfigurationsAPIRoutes {
    GET_HALLS = "hall:query",
    GET_HALL_INFO_WITH_ID = "hall:get",
    GET_CONFIGURATIONS_LIST = "config:settings:versions",

    //LIST_SCHEMAS = "config:schema:list:full",
    GET_SCHEMA = "config:schema:get:full",

    GET_CORE_VERSIONS = "config:lists:versions:system_server",

    GET_CONFIGURATION = "config:settings:get",
    NEW_CONFIGURATION = "config:settings:create",
    DOWNLOAD_CONFIGURATION = "config:settings:download",
    EDIT_CONFIGURATION = "config:settings:update",

    GET_SERVER = "server:get",

    GET_DENOMINATIONS = "config:lists:denominations:query",
    GET_CURRENCIES = "config:lists:currencies:query",

    GET_GAME_INSTANCES_CONFIGS = "games:configuration:query",
    GET_GAME_CONFIGS = "games:configuration:active",
    GET_GAMES = "games:games:query",

    GET_SOUND_DECIBELS = "config:lists:volume:decibels",
    GET_SOUND_PERCENTAGE = "config:lists:volume:percentage",
    GET_SOUND_SERVER_SETTINGS = "config:settings:sounds",
    GET_SOUND_GROUPS = "config:lists:sound:groups",

    GET_RTP_PROFILES = "games:rtp-profile:query",

    GET_PROGRESSIVE_TYPES = "config:settings:progressives:types",
    GET_PROGRESSIVE_PRESETS = "config:settings:progressives:presets",
    GET_PROGRESSIVE_RULES = "config:settings:progressives:rules",

    GET_BUNDLES = "games:bundle:query",
    GET_GAME = "games:game:fetch",

    GET_REGIONS = "config:settings:regions",
    GET_MAILING_LISTS = "config:settings:mail",

    GET_PRODUCTION_INFO="system:production:sys:get",

    GET_MEGAPOT_SERVER_LIST="config:settings:megapot:server",

    GET_MEGAPOT_PROVIDERS_LIST="config:settings:megapot:providers"
}
